<template>
  <figure style="width: 100%; height: 100%;display: flex;align-items: center;justify-content: center;">
    <chart :options="radialOptions" ref="bar" auto-resize style='width: 100%; height: 100%' v-if="dataState === 'ready'"></chart>
    <template v-else-if="dataState === 'loading'">
      <center>
        <v-progress-circular
          :size="70"
          :width="7"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </center>
    </template>
    <template v-else-if="dataState === 'noData'">
      <div class="d-flex" style="flex-direction: column; align-items: center"><v-icon class="primary--text" style="font-size: 40px !important;width:100%">warning</v-icon><p class="accent--text mb-0 ml-2 subheading font-weight-bold">no data found</p></div>
    </template>
    <template v-else-if="dataState === 'error'">
      <div class="d-flex" style="flex-direction: column; align-items: center"><v-icon class="error--text" style="font-size: 40px !important">warning</v-icon><p class="accent--text mb-0 ml-2 subheading font-weight-bold">error connecting to server</p></div>
    </template>
  </figure>
</template>

<script>
import axios from 'axios'
import underscore from 'underscore'
import { mapGetters, mapMutations } from 'vuex'
import 'echarts/lib/chart/bar'

export default {
  props: {
    filters: {
      type: Object,
      default: () => ({})
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      dataState: 'loading',
      radialOptions: {
        angleAxis: { type: 'category', data: [] },
        radiusAxis: { },
        polar: { },
        series: [],
        legend: { show: true, data: []
        }
      }
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
    ...mapGetters('filters', ['getQuery'])
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    ...mapMutations('filters', ['setCustomFilters']),
    getData: function () {
      this.dataState = 'loading'
      axios.all([
        this.$store.dispatch('getTwitterUsersWithQtsandRts', this.getQuery({sortBy: '_tweet_count', order: 'DESC', pageSize: 10}))
      ]).then(axios.spread((r1) => {
        if (r1.data.status === 'SUCCESS') {
          let replyCount = { type: 'bar', data: [], coordinateSystem: 'polar', name: 'Replies', stack: 'a' }
          let tweetCount = { type: 'bar', data: [], coordinateSystem: 'polar', name: 'Tweets', stack: 'a' }
          let quoteCount = { type: 'bar', data: [], coordinateSystem: 'polar', name: 'Quotes', stack: 'a' }
          let retweetCount = { type: 'bar', data: [], coordinateSystem: 'polar', name: 'Retweets', stack: 'a' }
          let data = ['Tweets', 'Replies', 'Quotes', 'Retweets']
          let users = []
          if (r1.data.payload.length === 0) {
            this.dataState = 'noData'
          } else {
            for (var i = 0; i < r1.data.payload.length; i++) {
              tweetCount.data.push(r1.data.payload[i]._tweet_count - (r1.data.payload[i]._retweet_quote_count + r1.data.payload[i]._retweet_reply_count + r1.data.payload[i]._quote_reply_count) + 2 * r1.data.payload[i]._retweet_quote_reply_count)
              retweetCount.data.push(r1.data.payload[i]._retweet_count)
              replyCount.data.push(r1.data.payload[i]._reply_count - (r1.data.payload[i]._retweet_reply_count + r1.data.payload[i]._quote_reply_count) + r1.data.payload[i]._retweet_quote_reply_count)
              quoteCount.data.push(r1.data.payload[i]._quote_count - (r1.data.payload[i]._retweet_quote_count + r1.data.payload[i]._quote_reply_count) + r1.data.payload[i]._retweet_quote_reply_count)
              users.push('@' + r1.data.payload[i]._screen_name)
            }
            this.radialOptions.legend = { show: true, data: data }
            this.radialOptions.series = [quoteCount, replyCount, retweetCount, tweetCount]
            this.radialOptions.angleAxis = { type: 'category', axisLabel: { interval: 0 }, data: users, z: 10 }
            this.radialOptions.tooltip = { show: true, axisPointer: { type: 'cross' } }
            this.dataState = 'ready'
          }
        } else {
          this.dataState = 'error'
          this.notify({message: 'Something went wrong while fetching data.', show: true})
        }
      })).catch((err) => {
        this.dataState = 'error'
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    }
  },
  watch: {
    filters: {
      deep: true,
      immediate: true,
      handler (newVal, oldVal) {
        if (!underscore.isEqual(newVal, oldVal) && this.filters.dirty === false) {
          this.getData()
        }
      }
    },
    loading: {
      immediate: true,
      handler (newVal, oldVal) {
        if (newVal === true) {
          let bar = this.$refs.bar
          if (bar) {
            bar.showLoading({
              text: '',
              color: '#4ea397',
              maskColor: 'rgba(255, 255, 255, 0.4)'
            })
          }
        } else {
          let bar = this.$refs.bar
          if (bar) {
            bar.hideLoading()
          }
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/charts/UsersPolarChart.vue